import {
  IcoBolt24,
  IcoBuilding24,
  IcoCrosshair24,
  IcoEmojiHappy24,
  IcoEye24,
  IcoFileSearch24,
  IcoFileText24,
  IcoLock24,
  IcoMegaphone24,
  IcoNetwork24,
  type Icon,
  IcoRobot24,
  IcoShield24,
  IcoShieldFlash24,
  IcoShuffle24,
  IcoSparkles24,
  IcoSpeedometer24,
  IcoSquareFrame24,
  IcoStore24,
  IcoUserstore24,
  IcoVisaPassport24,
  IcoVoter24,
  IcoWand24,
  IcoWarning24,
  IcoWork24,
} from '@onefootprint/icons';

const AGENT_ICONS = [
  'ico_robot',
  'ico_emoji_happy',
  'ico_sparkles',
  'ico_wand',
  'ico_userstore',
  'ico_store',
  'ico_building',
  'ico_work',
  'ico_warning',
  'ico_eye',
  'ico_visa_passport',
  'ico_voter',
  'ico_file_search',
  'ico_file_text',
  'ico_square_frame',
  'ico_crosshair',
  'ico_shield_flash',
  'ico_shield',
  'ico_shuffle',
  'ico_bolt',
  'ico_speedometer',
  'ico_network',
  'ico_megaphone',
  'ico_lock',
] as const;

type AgentIconKind = (typeof AGENT_ICONS)[number];

const AGENT_ICON_COMPONENTS: Record<AgentIconKind, Icon> = {
  ico_robot: IcoRobot24,
  ico_emoji_happy: IcoEmojiHappy24,
  ico_sparkles: IcoSparkles24,
  ico_wand: IcoWand24,
  ico_userstore: IcoUserstore24,
  ico_store: IcoStore24,
  ico_building: IcoBuilding24,
  ico_work: IcoWork24,
  ico_warning: IcoWarning24,
  ico_eye: IcoEye24,
  ico_visa_passport: IcoVisaPassport24,
  ico_voter: IcoVoter24,
  ico_file_search: IcoFileSearch24,
  ico_file_text: IcoFileText24,
  ico_square_frame: IcoSquareFrame24,
  ico_crosshair: IcoCrosshair24,
  ico_shield_flash: IcoShieldFlash24,
  ico_shield: IcoShield24,
  ico_shuffle: IcoShuffle24,
  ico_bolt: IcoBolt24,
  ico_speedometer: IcoSpeedometer24,
  ico_network: IcoNetwork24,
  ico_megaphone: IcoMegaphone24,
  ico_lock: IcoLock24,
};

export const DEFAULT_AGENT_ICON = 'ico_robot';

export type { AgentIconKind };
export { AGENT_ICON_COMPONENTS, AGENT_ICONS };
export default AGENT_ICONS;
